import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import TextEditor from 'flarum/common/components/TextEditor';
import TextEditorButton from 'flarum/common/components/TextEditorButton';

const translationPrefix = 'cns-emoji.forum.';

let emojioneAreaLoaded = false;

function assetUrl(file) {
  const base = (app.forum.attribute('cnsEmojiAssetBase') || '/assets/extensions/tf-cns-emoji').replace(/\/$/, '');
  return base + '/' + file;
}

function loadCss(href) {
  if (document.querySelector(`link[data-cns-emoji="1"][href="${href}"]`)) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const style = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = href;
    style.dataset.cnsEmoji = '1';
    style.onload = () => resolve();
    style.onerror = reject;
    document.head.appendChild(style);
  });
}

function loadScript(src) {
  if (document.querySelector(`script[data-cns-emoji="1"][src="${src}"]`)) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.dataset.cnsEmoji = '1';
    script.onload = () => resolve();
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

/**
 * Prefer Unicode glyphs; keep converters safe if any leftover img templates appear.
 */
function preferUnicodeEmojione() {
  const emojione = window.emojione;
  if (!emojione || emojione.__cnsEmojiUnicode) {
    return;
  }

  emojione.__cnsEmojiUnicode = true;
  const shortnameToUnicode = emojione.shortnameToUnicode.bind(emojione);

  emojione.sprites = false;
  emojione.shortnameToImage = (str) => shortnameToUnicode(str);
  emojione.unicodeToImage = (str) => str;
  emojione.toImage = (str) => shortnameToUnicode(str);
}

function loadEmojioneArea() {
  if (emojioneAreaLoaded) {
    return Promise.resolve();
  }

  emojioneAreaLoaded = true;
  window.emojioneVersion = '3.1.2';

  return loadCss(assetUrl('emojionearea.min.css'))
    .then(() => loadScript(assetUrl('emojione.min.js')))
    .then(() => {
      preferUnicodeEmojione();
      return loadScript(assetUrl('emojionearea.min.js'));
    });
}

app.initializers.add('tf-cns-emoji', () => {
  TextEditor.prototype.cnsEmojiClickedOutside = function (event) {
    if (!this.cnsEmojiArea || !this.cnsEmojiArea.isReady || !this.cnsEmojiOpen) {
      return;
    }

    const $target = $(event.target);

    if ($target.closest('.emojionearea, .Button-cnsEmoji').length) {
      return;
    }

    this.cnsEmojiArea.hidePicker();
    this.cnsEmojiOpen = false;
  };

  TextEditor.prototype.configureCnsEmoji = function () {
    if (this.cnsEmojiArea && this.$('.ComposerBody-cnsEmojiContainer').length) {
      return Promise.resolve();
    }

    this.cnsEmojiArea = null;
    this.cnsEmojiOpen = false;
    this.$('.ComposerBody-cnsEmojiContainer').remove();

    const $container = $('<div class="ComposerBody-cnsEmojiContainer"/>');
    this.$('.TextEditor-controls').before($container);

    return new Promise((resolve) => {
      const filters = {};

      Object.keys($().emojioneArea.defaults.filters).forEach((filter) => {
        const key = translationPrefix + 'filters.' + filter;

        if (key in app.translator.translations) {
          filters[filter] = {
            title: app.translator.trans(key),
          };
        }
      });

      preferUnicodeEmojione();

      const area = $('<div />').emojioneArea({
        standalone: true,
        sprite: false,
        useInternalCDN: false,
        hidePickerOnBlur: false,
        searchPlaceholder: app.translator.trans(translationPrefix + 'search_placeholder'),
        buttonTitle: app.translator.trans(translationPrefix + 'picker_button'),
        container: $container,
        filters,
        events: {
          emojibtn_click: () => {
            this.attrs.composer.editor.insertAtCursor(this.cnsEmojiArea.getText());

            if (app.forum.attribute('cnsEmojiCloseOnPick')) {
              this.cnsEmojiArea.hidePicker();
              this.cnsEmojiOpen = false;
            }
          },
          ready: resolve,
        },
        ...app.forum.attribute('cnsEmojiConfig'),
      });

      this.cnsEmojiArea = area.data('emojioneArea');
    });
  };

  extend(TextEditor.prototype, 'oncreate', function () {
    this.cnsEmojiArea = null;
    this.cnsEmojiLoading = false;
    this.cnsEmojiOpen = false;

    this.cnsEmojiClickedOutsideBound = this.cnsEmojiClickedOutside.bind(this);
    document.addEventListener('click', this.cnsEmojiClickedOutsideBound);
  });

  extend(TextEditor.prototype, 'onremove', function () {
    if (this.cnsEmojiClickedOutsideBound) {
      document.removeEventListener('click', this.cnsEmojiClickedOutsideBound);
      this.cnsEmojiClickedOutsideBound = null;
    }
  });

  extend(TextEditor.prototype, 'toolbarItems', function (items) {
    items.add(
      'cns-emoji',
      TextEditorButton.component({
        onclick: (e) => {
          e.stopPropagation();

          if (this.cnsEmojiLoading) {
            return;
          }

          if (this.cnsEmojiArea && this.cnsEmojiOpen) {
            this.cnsEmojiArea.hidePicker();
            this.cnsEmojiOpen = false;
            return;
          }

          this.cnsEmojiLoading = true;

          loadEmojioneArea()
            .then(() => this.configureCnsEmoji())
            .then(() => {
              const position = this.$('.Button-cnsEmoji').position();
              if (position) {
                this.$('.emojionearea-picker').css('left', position.left - 290);
              }
              this.cnsEmojiArea.showPicker();
              this.cnsEmojiOpen = true;
              $('.emojionearea-search input').focus();
            })
            .catch(() => {
              this.cnsEmojiOpen = false;
            })
            .finally(() => {
              this.cnsEmojiLoading = false;
            });
        },
        className: 'Button Button--icon Button--link Button-cnsEmoji',
        icon: this.cnsEmojiLoading ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-smile-beam',
        title: app.translator.trans(translationPrefix + 'picker_button'),
      })
    );
  });
});

app.initializers.add(
  'tf-cns-emoji-after',
  () => {
    extend(TextEditor.prototype, 'toolbarItems', function (items) {
      if (app.forum.attribute('cnsEmojiHideFlarumButton') && items.has('emoji')) {
        items.remove('emoji');
      }
    });
  },
  -100
);
